<template>
  <Comprador />
</template>

<script>
import Comprador from "@/components/cfg/CfgComprador";

export default {
  components: { Comprador }
}
</script>

<style>

</style>
